import getSiteId from './site-id';

export default {
  getSiteId,
};
